import PropTypes from 'prop-types';
import moment from 'moment';
import React from 'react';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import * as dates from 'react-schedule-calendar/lib/utils/dates';
import { navigate } from 'react-schedule-calendar/lib/utils/constants';
import { StaticDatePicker } from '@mui/x-date-pickers';
import {
  sortEvents,
  inRange,
} from 'react-schedule-calendar/lib/utils/eventLevels';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  events: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  event: {
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.pxToRem(14),
    cursor: 'pointer',
  },
  calendar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    borderTop: '1px solid #DDD',
    borderBottom: '1px solid #DDD',
  },
});

class QuickDayView extends React.Component {
  render() {
    const {
      classes,
      className,
      date,
      events: allEvents,
      accessors,
      onSelectEvent,
      onNavigate,
      components: { event: Event },
    } = this.props;

    const range = QuickDayView.range(date);
    const start = range[0];
    const end = range[range.length - 1];

    const events = allEvents
      .sort((a, b) => sortEvents(a, b, accessors))
      .filter(event => inRange(event, start, end, accessors));

    return (
      <div className={classNames(classes.container, className)}>
        <div className={classes.calendar}>
          <StaticDatePicker
            variant="static"
            slots={{ toolbar: null }}
            slotProps={{ actionBar: { actions: [] } }}
            openTo="day"
            value={moment(date)}
            onChange={date => {
              onNavigate(undefined, date);
            }}
          />
        </div>
        <div className={classNames(classes.events, className)}>
          {events.map(event => {
            let title = accessors.title(event);
            return (
              <Event
                key={event._id}
                className={classes.event}
                event={event}
                title={title}
                onSelect={onSelectEvent}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

QuickDayView.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

QuickDayView.range = date => {
  return [dates.startOf(date, 'day')];
};

QuickDayView.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, 'day');

    case navigate.NEXT:
      return dates.add(date, 1, 'day');

    default:
      return date;
  }
};

QuickDayView.title = (date, { localizer }) =>
  localizer.format(date, 'dayHeaderFormat');

export default withStyles(styles)(QuickDayView);
